import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './configs/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'
import { AUTH } from './configs/firebase'
import { onAuthStateChanged } from 'firebase/auth'

import 'typeface-poppins'
import './registerServiceWorker'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.config.productionTip = false

const sweetAlert2options = {
  confirmButtonColor: '#9633DF'
}

Vue.use(VueSweetalert2, sweetAlert2options)

let app
onAuthStateChanged(AUTH, async (user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App)
    }).$mount('#app')
  }

  if (user) {
    store.commit('users/SET_AUTH_USER', user)
    await store.dispatch('users/LOAD_LOGGED_IN_USER', user.uid)
    return
  }

  store.commit('users/SET_AUTH_USER', null)
  store.commit('users/RESET_USER')
})
